export default __webpack_public_path__ + "static/media/kalechips-wide@3x.0d9caae4.jpg";